import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';

import './style.scss';

const EditGig = ({ username, slug }, { pathfinderWrapper }) => {
    const editGigLink = pathfinderWrapper.pathfinder('edit_user_manage_gig',
        {
            user_id: username,
            id: slug
        });

    return (
        <a href={editGigLink} className="edit-gig"><I18n k={'gig_page_perseus.top_nav.edit_gig'}/></a>
    );
};

EditGig.propTypes = {
    username: PropTypes.string,
    slug: PropTypes.string
};

EditGig.contextTypes = {
    pathfinderWrapper: PropTypes.object
};

export default EditGig;

